// extracted by mini-css-extract-plugin
export default {"PushNotificationsPageWrapper":"PushNotificationsPage_PushNotificationsPageWrapper__ExZHL"};